const propelInit = function() {
const accordionImageBlocks = document.querySelectorAll(
	'.block-accordion-image'
);

const INTERACTION_EVENTS = [
	'scroll',
	'mousemove',
	'touchstart',
	'pointerdown',
	'keydown',
	'focusin',
];

const showAllImages = () => {
	INTERACTION_EVENTS.forEach((event) => {
		document.removeEventListener(event, showAllImages);
	});

	accordionImageBlocks.forEach((block) => {
		block.classList.add('block-accordion-image--images-ready');
	});
};

if (accordionImageBlocks.length) {
	// Inactive images wait for the first interaction so they don't compete with the initial page load.
	INTERACTION_EVENTS.forEach((event) => {
		document.addEventListener(event, showAllImages, { passive: true });
	});
}

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['accordion-image'] = window.propel.blocks['accordion-image'] || {};
window.propel.blocks['accordion-image'].script = propelInit;
